import { useKeycloak } from "@react-keycloak/web"
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPennant, faCogs, faFileInvoice, faAlbumCollection } from "@fortawesome/pro-light-svg-icons";
import { useNavigate } from "react-router-dom";
import { Image } from 'primereact/image';

export default function Sidebar2({ visible, hideSidebar }) {
    const { keycloak } = useKeycloak();
    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(path);
        if (visible) {
            hideSidebar();
        }
    }

    return (
        <>
            {/* Backdrop only renders/shows on narrow screens (see CSS) when the
                slide-in overlay is open; clicking it closes the sidebar. */}
            <div className={"sidebar-backdrop" + (visible ? " sidebar-open" : "")} onClick={hideSidebar} />
            <div id="sidebar" className={visible ? "sidebar-open" : ""}>
                <div>
                    <div className="flex-col align-center pointer" onClick={() => navigate('/')}>
                        <div style={{ fontSize: 40 }}>
                            Featurely
                        </div>
                        <div style={{ fontSize: 10 }}>
                            By New Labs
                        </div>
                        <Image src="/flag.png" width={100}/>
                    </div>
                    <div>
                        <div className="sidebar-link pointer" style={{ fontSize: 28 }} onClick={() => handleNavigate("/projects")}>
                            <FontAwesomeIcon icon={faAlbumCollection} style={{ marginRight: 10, fontSize: 20 }} />Projects
                        </div>
                        <div className="sidebar-link pointer" style={{ fontSize: 28 }} onClick={() => handleNavigate("/flags")}>
                            <FontAwesomeIcon icon={faPennant} style={{ marginRight: 10, fontSize: 20 }} />Flags
                        </div>
                        <div className="sidebar-link pointer" style={{ fontSize: 28}} onClick={() => handleNavigate("/documentation")}>
                            <FontAwesomeIcon icon={faFileInvoice} style={{ marginRight: 10, fontSize: 20 }} />How-To Guides
                        </div>
                        <div className="sidebar-link pointer" style={{ fontSize: 28 }} onClick={() => handleNavigate("/about")}>
                            <FontAwesomeIcon icon={faCogs} style={{ marginRight: 10, fontSize: 20 }} />About
                        </div>
                        <Divider />
                    </div>
                </div>
                <div>
                    <div className="audit-details">
                        <div>Version: {window.VERSION} Build: {window.BUILD}</div>
                        <div>Need support? admin@new-labs.co</div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <div className="audit-details">New Labs System Status</div>
                        <statuspage-widget src="https://newlabs.statuspage.io"></statuspage-widget>
                    </div>

                    <div className="mt10">
                        <Button className="p-button-warning" icon="pi pi-sign-out" label="Logout" onClick={() => keycloak.logout()} />
                    </div>
                </div>
            </div>
        </>
    )
}